<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"/>
    </div>
    <div class="form-npa m-t-40 user-create-pg">
      <div class="position">
        <div class="bg-white p-20">
          <v-form
            action
            @submit.prevent="createUser"
            enctype="multipart/form-data"
            ref="createForm"
          >
            <div class="form-head">
              <Widget position="menu_profile"/>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    v-on="on"
                    class="navbar-toggler-profile"
                  >
                    {{ $t('Профиль') }} <span class="caret"></span>
                  </v-btn>
                </template>
                <v-list class="navbar-collapse">
                  <v-list-item>
                    <Widget position="menu_profile"/>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="form-body">
              <div class="form-col-2">
                <div
                  :class="{ invalid: $v.user.email.$error || errorMessages.email }"
                  class="form-group"
                >
                  <label>
                    {{ $t('Электронный адрес почты') }}
                    <span class="asterix">*</span>
                    <fieldInfo/>
                  </label>
                  <div class="input-field">
                    <v-text-field
                      v-model.trim="user.email"
                      type="email"
                      required
                      outlined
                      rounded
                      dense
                      clearable
                      name="user[email]"
                    />
                    <small v-if="errorMessages.email" class="invalid">{{ $t(`${errorMessages.email}`) }}</small>
                  </div>
                </div>
                <div
                  :class="{ invalid: $v.user.pass.$error || errorMessages.pass }"
                  class="form-group"
                >
                  <label>
                    {{ $t('Пароль') }}
                    <span class="asterix">*</span>
                    <fieldInfo/>
                  </label>
                  <div class="input-field">
                    <v-text-field
                      v-model.trim="user.pass"
                      type="password"
                      required
                      outlined
                      rounded
                      dense
                      name="user[pass]"
                    />
                    <small v-if="errorMessages.pass" class="invalid">{{ $t(`${errorMessages.pass}`) }}</small>
                  </div>
                </div>
                <div
                  :class="{
                    invalid:
                      ($v.user.pass.$dirty && !$v.user.pass.required) ||
                      ($v.user.repeatPassword.$dirty && user.repeatPassword !== user.pass)
                  }"
                  class="form-group"
                >
                  <label>
                    {{ $t('Подтверждение пароля') }}
                    <span class="asterix">*</span>
                    <fieldInfo/>
                  </label>
                  <div class="input-field">
                    <v-text-field
                      v-model.trim="user.repeatPassword"
                      type="password"
                      required
                      outlined
                      rounded
                      dense
                    />
                    <small
                      v-if="$v.user.repeatPassword.$dirty && user.pass !== user.repeatPassword"
                      class="helper-text invalid"
                    >
                      {{ $t("Пароль должен совпадать. Попробуйте еще") }}
                    </small>
                  </div>
                </div>
                <div
                  :class="{ invalid: $v.user.firstName.$error || errorMessages.firstName }"
                  class="form-group"
                >
                  <label>
                    {{ $t('Имя') }}
                    <span class="asterix">*</span>
                    <fieldInfo/>
                  </label>
                  <div class="input-field">
                    <v-text-field
                      v-model="user.firstName"
                      required
                      outlined
                      rounded
                      dense
                      clearable
                      name="user[firstName]"
                    />
                    <small v-if="errorMessages.firstName" class="invalid">{{ $t(`${errorMessages.firstName}`) }}</small>
                  </div>
                </div>
                <div
                  :class="{ invalid: $v.user.secondName.$error || errorMessages.secondName }"
                  class="form-group"
                >
                  <label>
                    {{ $t('Фамилия') }}
                    <span class="asterix">*</span>
                    <fieldInfo/>
                  </label>
                  <div class="input-field">
                    <v-text-field
                      v-model="user.secondName"
                      required
                      outlined
                      rounded
                      dense
                      clearable
                      name="user[secondName]"
                    />
                    <small v-if="errorMessages.secondName" class="invalid">{{ $t(`${errorMessages.secondName}`) }}</small>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{ $t('Отчество') }}
                    <fieldInfo/>
                  </label>
                  <v-text-field
                    v-model="user.lastName"
                    required
                    outlined
                    rounded
                    dense
                    clearable
                    name="user[lastName]"
                  />
                  <i v-if="errorMessages.lastName" class="invalid">{{ $t(errorMessages.lastName) }}</i>
                </div>
                <div
                    :class="{ invalid: $v.user.nickName.$error || errorMessages.nickName }"
                    class="form-group"
                >
                  <label>{{ $t('Логин') }}
                    <span class="asterix">*</span>
                    <fieldInfo/>
                  </label>
                  <v-text-field
                    v-model.trim="user.nickName"
                    required
                    outlined
                    rounded
                    dense
                    clearable
                    name="user[nickName]"
                  />
                  <i v-if="errorMessages.nickName" class="invalid">{{ $t(errorMessages.nickName) }}</i>
                </div>
                <div
                  class="form-group"
                  :class="{ invalid: $v.user.systemRoles.$error || errorMessages.systemRoles }"
                >
                  <label>{{ $t('Роль') }}
                    <span class="asterix">*</span>
                    <fieldInfo/>
                  </label>
                  <div class="input-field">
                    <v-select
                      multiple
                      required
                      item-value="id"
                      item-text="transName"
                      v-model="user.systemRoles"
                      :items="formData.systemRoles"
                      input="transName"
                      outlined
                      rounded
                      dense
                      name="user[systemRoles]"
                    />
                    <small v-if="errorMessages.systemRoles" class="invalid">{{ $t(`${errorMessages.systemRoles}`) }}</small>
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{ invalid: $v.user.developer.$error || errorMessages.developer }"
                >
                  <label>{{ $t('Разработчик') }}
                    <span class="asterix">*</span>
                    <fieldInfo/>
                  </label>
                  <div class="input-field">
                    <v-select
                      item-value="id"
                      item-text="transName"
                      required
                      v-model="user.developer"
                      :items="formData.developer"
                      input="transName"
                      outlined
                      rounded
                      dense
                      name="user[developer]"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-icon class="select-def__icon">
                          <v-icon :class="item.status === false ? 'nv_icon' : ''" x-small/>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.transName }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-select>
                    <small v-if="errorMessages.developer" class="invalid">{{ $t(`${errorMessages.developer}`) }}</small>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{ $t('Адрес') }}
                    <fieldInfo/>
                  </label>
                  <v-text-field
                    v-model="user.address"
                    required
                    outlined
                    rounded
                    dense
                    clearable
                    name="user[address]"
                  />
                  <i v-if="errorMessages.address" class="invalid">{{ $t(errorMessages.address) }}</i>
                </div>
                <div class="form-group">
                  <label>{{ $t('Гражданство') }}
                    <fieldInfo/>
                  </label>
                  <v-select
                    item-value="id"
                    item-text="transName"
                    v-model="user.citizenship"
                    :items="formData.citizenship"
                    input="transName"
                    outlined
                    rounded
                    dense
                    name="user[citizenship]"
                  />
                  <i v-if="errorMessages.citizenship" class="invalid">{{ $t(errorMessages.citizenship) }}</i>
                </div>
                <div class="form-group">
                  <label>{{ $t('Пол') }}
                    <fieldInfo/>
                  </label>
                  <v-select
                    item-value="id"
                    item-text="transName"
                    v-model="user.sex"
                    :items="formData.sex"
                    input="transName"
                    outlined
                    rounded
                    dense
                    name="user[sex]"
                  />
                  <i v-if="errorMessages.sex" class="invalid">{{ $t(errorMessages.sex) }}</i>
                </div>
                <div class="form-group">
                  <label>{{ $t('Дата рождения') }}
                    <fieldInfo/>
                  </label>
                  <div class="form-date">
                    <v-menu
                      v-model="adoptionDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="user.birthDate"
                          required
                          readonly
                          v-on="on"
                          outlined
                          rounded
                          dense
                          name="user[birthDate]"
                        />
                      </template>
                      <v-date-picker
                        v-model="user.birthDate"
                        @input="adoptionDateMenu = false"
                        :weekday-format="getDay"
                        :month-format="getMonthFormat"
                        :header-date-format="getHeaderDateFormat"
                        no-title
                        first-day-of-week="1"
                      />
                    </v-menu>
                  </div>
                  <i v-if="errorMessages.birthDate" class="invalid">{{ $t(errorMessages.birthDate) }}</i>
                </div>
                <div class="form-group">
                  <label>{{ $t('Телефон') }}
                    <fieldInfo/>
                  </label>
                  <v-text-field
                    v-model="user.phone"
                    required
                    outlined
                    rounded
                    dense
                    clearable
                    name="user[phone]"
                  />
                </div>
                <i v-if="errorMessages.phone" class="invalid">{{ $t(errorMessages.phone) }}</i>
                <div class="form-group">
                  <label>{{ $t('Изображение') }}
                    <fieldInfo/>
                  </label>
                  <v-file-input
                    v-model="user.uploadedFile"
                    outlined
                    rounded
                    dense
                    name="user[uploadedFile]"
                  />
                  <i v-if="errorMessages.uploadedFile" class="invalid">{{ $t(errorMessages.uploadedFile) }}</i>
                </div>
                <div class="form-group">
                  <label>{{ $t('Отдел') }}
                    <fieldInfo/>
                  </label>
                  <v-text-field
                    v-model="user.department"
                    required
                    outlined
                    rounded
                    dense
                    clearable
                    name="user[department]"
                  />
                  <i v-if="errorMessages.department" class="invalid">{{ $t(errorMessages.department) }}</i>
                </div>
                <div class="form-group">
                  <label>{{ $t('Должность') }}
                    <fieldInfo/>
                  </label>
                  <v-select
                    item-value="id"
                    item-text="transName"
                    v-model="user.post"
                    :items="formData.post"
                    input="transName"
                    outlined
                    rounded
                    dense
                    clearable
                    name="user[post]"
                  />
                  <i v-if="errorMessages.post" class="invalid">{{ $t(errorMessages.post) }}</i>
                </div>
<!--                <div class="form-group">-->
<!--                  <label>{{ $t('Заблокированные разрешения ролей') }}-->
<!--                    <fieldInfo/>-->
<!--                  </label>-->
<!--                  <v-select-->
<!--                    item-value="id"-->
<!--                    item-text="transName"-->
<!--                    v-model="user.lockedSystemRolePermissions"-->
<!--                    :items="formData.permissions"-->
<!--                    input="transName"-->
<!--                    outlined-->
<!--                    rounded-->
<!--                    dense-->
<!--                    multiple-->
<!--                    clearable-->
<!--                    chips-->
<!--                    name="user[lockedSystemRolePermissions]"-->
<!--                  />-->
<!--                  <i v-if="errorMessages.lockedSystemRolePermissions" class="invalid">{{ $t(errorMessages.lockedSystemRolePermissions) }}</i>-->
<!--                </div>-->
<!--                <div class="form-group">-->
<!--                  <label>{{ $t('Дополнительные разрешения пользователя') }}-->
<!--                    <fieldInfo/>-->
<!--                  </label>-->
<!--                  <v-select-->
<!--                    item-value="id"-->
<!--                    item-text="transName"-->
<!--                    v-model="user.permissions"-->
<!--                    :items="formData.permissions"-->
<!--                    input="transName"-->
<!--                    outlined-->
<!--                    rounded-->
<!--                    dense-->
<!--                    multiple-->
<!--                    chips-->
<!--                    clearable-->
<!--                    name="user[permissions]"-->
<!--                  />-->
<!--                  <i v-if="errorMessages.permissions" class="invalid">{{ $t(errorMessages.permissions) }}</i>-->
<!--                </div>-->
              </div>
            </div>
            <div class="form-bottom">
              <div class="form-group form-action">
                <button class="btn btn-default blue" type="submit">
                  {{ $t('Сохранить') }}
                </button>
                <button
                  class="btn btn-default white"
                  @click="onCancel"
                >
                  {{ $t('Отмена') }}
                </button>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import User from '@/model/user'
import Widget from '@/components/app/Widget'
import { mapMutations } from 'vuex'
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
import fieldInfo from '@/components/app/fieldInfo'
import mixin from '@/plugins/mixin/mixin'
import { Trans } from "@/plugins/Translation"

export default {
  mixins: [mixin],
  components: {
    Widget,
    fieldInfo
  },
  data: () => ({
    valid: true,
    user: {
      email: '',
      pass: '',
      repeatPassword: '',
      firstName: '',
      secondName: '',
      lastName: '',
      nickName: '',
      address: '',
      systemRoles: '',
      citizenship: '',
      sex: '',
      birthDate: '',
      phone: '',
      uploadedFile: '',
      developer: '',
      department: '',
      post: '',
      lockedSystemRolePermissions: '',
      permissions: '',
    },
    formData: {},
    adoptionDateMenu: false,
    breadcrumbs: [],
    errorMessages: {}
  }),
  validations: {
    user: {
      email: { required, email },
      pass: {
        required,
        minLength: minLength(8)
      },
      repeatPassword: {
        sameAsPassword: sameAs('pass')
      },
      firstName: { required },
      secondName: { required },
      nickName: { required },
      systemRoles: { required },
      developer: { required },
    }
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: 'fetchData',
  },
  created () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      User.getFormData().then((response) => {
        this.formData = response.data
        this.generateBreadcrumbs()
        this.setLoading(false)
      }).catch((error) => {
        this.$router.push(Trans.i18nRoute({
          name: 'error',
          params: {
            status: error.response.status
          }
        }))
        this.setLoading(false)
      })
    },
    // генерация хлебных крошек
    generateBreadcrumbs() {
      this.breadcrumbs = [
        {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
        {text: this.$i18n.t('Управление доступом'), disabled: false, href: Trans.currentLocaleUrl + '/users'},
        {text: this.$i18n.t('Создание пользователя'), disabled: true},
      ]
    },
    // Валидация формы
    validateForm() {
      this.$v.$touch()

      if (this.$v.$invalid) {

        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }
      return true
    },
    createUser () {
      if (!this.validateForm()) {
        return
      }

      const formEl = this.$refs.createForm.$el
      let fd = new FormData(formEl)

      User.createUser(fd).then((response) => {
        this.$router.push(Trans.i18nRoute({
          name: 'users',
        }))
      }).catch((error) => {
        if (error.response) {
          if (error.response.data.userForm) {
            let userForm = error.response.data.userForm
            let fields = userForm.data.errors.form.children
            this.$noty.error(this.$i18n.t(userForm.message), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })

            for (let field in fields) {

              if (fields[field].hasOwnProperty('errors')) {
                console.log('field: ',fields[field].errors.join())

                this.errorMessages[field] = fields[field].errors.join()
              }
            }
            if(this.errorMessages) {
              this.responseErrorValid()
              this.$nextTick(() => {
                this.scrollToFirstError()
              })
            }
          } else {
            this.$noty.error(error.message, {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          }
        } else {
          this.$noty.error(error.message, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        }
      })
    },
    // Отмена
    onCancel () {
      this.$router.push(Trans.i18nRoute({
        name: 'users'
      }))
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError() {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    //прокручиваем на начало страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
  }
}
</script>

<style>
  .input-field {
    margin: 0;
    overflow: hidden;
  }
</style>
